import type { ZerosslOrderState } from '../../../types/models/Certificate';
import type { CertificateBucketColor } from './certificateBuckets';

/**
 * Display maps for the ZeroSSL order state machine, shared by the list badge,
 * the detail-page header, and the order panel so the same state never renders
 * two different labels.
 *
 * `issued` is mostly invisible in practice: an issued order's certificate is
 * `status: 'ok'` and renders through the normal time-based buckets — the
 * issued entry exists for the transient success flash in the order panel.
 */
export const ZEROSSL_ORDER_STATE_LABELS: Record<ZerosslOrderState, string> = {
  pending: 'Validating',
  issued: 'Issued',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

export const ZEROSSL_ORDER_STATE_LABEL_COLORS: Record<ZerosslOrderState, CertificateBucketColor> = {
  pending: 'blue',
  issued: 'green',
  failed: 'red',
  cancelled: 'grey',
};
